import { useEffect, useState } from "react"

import { Page, Text, View, Document, Image, StyleSheet, Font } from '@react-pdf/renderer';

import { styles } from "../styles/styles";

// export const styles = StyleSheet.create({
//     heading1: {
//         fontFamily: 'Times-Bold',
//         fontSize: 13
//     },
//     heading2: {
//         fontFamily: 'Times-Roman',
//         fontSize: 9
//     },
//     documentName: {
//         fontFamily: 'Times-Bold',
//         fontSize: 15,
//         textAlign: 'center'
//     },
//     documentNumber: {
//         fontFamily: 'Times-Bold',
//         fontSize: 15,
//         textAlign: 'center'
//     }
// });

// document
// export function Header({ pageNumber, totalPages, document }) {

//     if (!document) return false

//     const {
//         header,
//         documentName,
//         documentNumber,
//     } = document;

//     // const {
//     //     lines: headerLines = []
//     // } = header

//     const headerLines = header?.lines ? header.lines : []

//     return (
//         <View style={styles.textDefault}>
//             <View
//                 style={{
//                     display: 'flex',
//                     flexDirection: 'row',
//                     justifyContent: 'space-between',
//                     alignItems: 'flex-start',
//                     // borderBottomColor: '#000',
//                     // borderBottomStyle: 'solid',
//                     // borderBottomWidth: 0.5,
//                 }}
//             >
//                 <View
//                     style={{
//                         width: '60%',
//                         flexWrap: 'wrap'
//                     }}>
//                     {/* <Text style={styles.heading1}>{billerCompany}</Text> */}
//                     {
//                         headerLines.map((i, index) => {

//                             // if(!i) return <Box key={index}></Box>

//                             return (
//                                 <Text
//                                     key={index}
//                                     style={
//                                         index === 0 ? styles.heading1 : styles.heading2
//                                     }
//                                 >{i}</Text>
//                             )
//                         })
//                     }
//                     {/* <Text
//                         style={styles.heading2}
//                     >
//                     {billerContact}
//                     </Text>  */}
//                 </View>
//                 <View
//                     style={{
//                         width: '35%',
//                         // flex: 1
//                     }}
//                 >
//                     <View
//                         style={{
//                             borderTopWidth: 1,
//                             borderTopStyle: 'solid',
//                             borderTopColor: '#000',

//                             borderBottomWidth: 1,
//                             borderBottomStyle: 'solid',
//                             borderBottomColor: '#000',

//                             borderLeftWidth: 1,
//                             borderLeftStyle: 'solid',
//                             borderLeftColor: '#000',

//                             borderRightWidth: 1,
//                             borderRightStyle: 'solid',
//                             borderRightColor: '#000',

//                             paddingTop: 2,
//                             paddingBottom: 2,
//                             paddingLeft: 4,
//                             paddingRight: 4,

//                             marginBottom: 5,

//                         }}
//                     >
//                         <Text
//                             style={styles.documentName}
//                         >
//                             {documentName.toUpperCase()}
//                         </Text>
//                     </View>
//                     <View>
//                         <Text style={styles.documentNumber}>
//                             {documentNumber}
//                         </Text>

//                     </View>
//                 </View>
//             </View>
//         </View>
//     )
// }

// label
// export function Header2({ pageNumber, totalPages, document, barCodeData, data }) {

//     let logoUrl = '/assets/images/customization/sdgrouphub/logoLabel.jpg';

//     if (!document) return false

//     const {
//         documentName,
//     } = document;

//     const RenderSection1 = () => {
//         return (
//             <View
//                 style={{
//                     width: '100%'
//                 }}
//             >
//                 <View
//                     style={{
//                         // borderTopWidth: 1,
//                         // borderTopStyle: 'solid',
//                         // borderTopColor: '#000',

//                         // borderBottomWidth: 1,
//                         // borderBottomStyle: 'solid',
//                         // borderBottomColor: '#000',

//                         // borderLeftWidth: 1,
//                         // borderLeftStyle: 'solid',
//                         // borderLeftColor: '#000',

//                         // borderRightWidth: 1,
//                         // borderRightStyle: 'solid',
//                         // borderRightColor: '#000',

//                     }}
//                 >
//                     <Image
//                         src={logoUrl}
//                         style={{
//                             width: '80',
//                             height: '40'
//                         }}
//                     />
//                 </View>
//             </View>
//         )
//     }

//     // const RenderSection2 = () => {

//     //     // console.log('data --> ', data)

//     //     let branchCode = data?.branchCode;

//     //     let branchCodeDisplay = '';

//     //     // if (branchCode.length > 0) {
//     //     //     branchCodeDisplay = branchCode[0]
//     //     // }

//     //     return (
//     //         <View
//     //             style={{
//     //                 width: '100%'
//     //             }}
//     //         >
//     //             <View
//     //                 style={{
//     //                     borderTopWidth: 1,
//     //                     borderTopStyle: 'solid',
//     //                     borderTopColor: '#000',

//     //                     borderBottomWidth: 1,
//     //                     borderBottomStyle: 'solid',
//     //                     borderBottomColor: '#000',

//     //                     borderLeftWidth: 1,
//     //                     borderLeftStyle: 'solid',
//     //                     borderLeftColor: '#000',

//     //                     borderRightWidth: 1,
//     //                     borderRightStyle: 'solid',
//     //                     borderRightColor: '#000',

//     //                     marginBottom: 5

//     //                 }}
//     //             >
//     //                 <Text
//     //                     // style={innerStyles.documentName}
//     //                     style={{
//     //                         textAlign: 'center',
//     //                         fontSize: 30
//     //                     }}
//     //                 >
//     //                     {/* {documentName.toUpperCase()} */}
//     //                     {branchCodeDisplay}
//     //                 </Text>
//     //             </View>
//     //             {/* <Text
//     //                 style={innerStyles.documentName}
//     //             >
//     //                 {data?.location_name}
//     //             </Text> */}
//     //         </View>
//     //     )
//     // }

//     const RenderSection3 = ({ barCodeData, pageNumber }) => {

//         // console.log('barCodeDatabarCodeDatabarCodeData', pageNumber, barCodeData[pageNumber - 1])

//         return (
//             <View
//                 style={{
//                     display: 'flex',
//                     flexDirection: 'column',
//                     justifyContent: 'flex-end',
//                 }}
//             >
//                 <View>
//                     {
//                         barCodeData[pageNumber - 1] &&
//                         <Image
//                             src={barCodeData[pageNumber - 1]}
//                             style={{
//                                 // width: '50',
//                                 height: '50'
//                             }}
//                         />
//                     }
//                     <Text>{document?.doc_number}</Text>
//                 </View>
//             </View>
//         )
//     }

//     return (
//         <View style={{
//             width: '100%',
//             marginBottom: 5,
//             // backgroundColor: 'red'
//         }}>
//             <View
//                 style={{
//                     display: 'flex',
//                     flexDirection: 'row',
//                     justifyContent: 'space-between',
//                     alignItems: 'flex-start',
//                     // borderBottomColor: '#000',
//                     // borderBottomStyle: 'solid',
//                     // borderBottomWidth: 0.5,
//                 }}
//             >
//                 <View
//                     style={{
//                         width: '50%',
//                         flexWrap: 'wrap'
//                     }}>
//                     <RenderSection1 />
//                 </View>
//                 {/* <View
//                     style={{
//                         width: '60%',
//                         flexWrap: 'wrap'
//                     }}>
//                     <RenderSection2 />
//                 </View> */}
//                 <View
//                     style={{
//                         width: '50%',
//                         // flex: 1
//                     }}
//                 >
//                     <RenderSection3
//                         barCodeData={barCodeData}
//                         pageNumber={pageNumber}
//                     />

//                 </View>
//             </View>
//             {/* <View
//                 style={{
//                     textAlign: 'right',
//                     // display: 'flex',
//                     // flexDirection: 'row',
//                     // justifyContent: 'space-between',
//                     // alignItems: 'center',
//                 }}
//             >
//                 <Text style={styles.h10}>
//                     {pageNumber} / {totalPages} ({data?.uom_lbl})
//                 </Text>
//             </View> */}
//         </View>
//     )
// }

// label product
export function Header3({ data }) {

    const RenderSection1 = () => {
        return (
            <View
                style={{
                    width: '100%',
                    height: 45,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "flex-start",

                    borderWidth: 1,
                    borderColor: '#000',
                    borderStyle: 'solid',
                    borderTopWidth: 0,
                    borderRightWidth: 0,
                    borderLeftWidth: 0,
                }}
            >
                <View
                    style={{
                        borderRightWidth: 1,
                        borderColor: '#000',
                        borderStyle: 'solid',

                        // backgroundColor: 'red',
                        width: "65%",
                        height: "100%",

                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        paddingLeft: 5,
                    }}
                >
                    <Text style={[styles.normalTextFamily, { fontSize: 24, fontWeight: 800, marginRight: 5 }]}>SD GROUP</Text>
                    <Text style={[styles.boldTextFamilyCN, { fontSize: 20, fontWeight: 800, marginTop: 5 }]}>梦界</Text>
                </View>
                <View
                    style={{
                        // backgroundColor: 'green',
                        width: "35%",
                        height: "100%",
                        paddingTop: 5,
                        paddingLeft: 5,
                    }}
                >
                    <View style={{ backgroundColor: "#000" }}>
                        <Text style={[styles.normalTextFamily, { textAlign: 'center', fontSize: 18, fontWeight: 800, color: "#fff" }]}>{data?.locationAbb}</Text>
                    </View>

                    <Text style={[styles.normalTextFamily, { textAlign: 'center', fontSize: 15, fontWeight: 800, color: "#000" }]}>
                        {data?.checkInDate}
                    </Text>

                    {/* <Image
                        src={barcodeDataUrl}
                        style={{
                            width: '80',
                            height: '40'
                        }}
                    /> */}
                </View>
            </View>
        )
    }

    // const RenderSection2 = () => {

    //     // console.log('data --> ', data)

    //     let branchCode = data?.branchCode;

    //     let branchCodeDisplay = '';

    //     // if (branchCode.length > 0) {
    //     //     branchCodeDisplay = branchCode[0]
    //     // }

    //     return (
    //         <View
    //             style={{
    //                 width: '100%'
    //             }}
    //         >
    //             <View
    //                 style={{
    //                     borderTopWidth: 1,
    //                     borderTopStyle: 'solid',
    //                     borderTopColor: '#000',

    //                     borderBottomWidth: 1,
    //                     borderBottomStyle: 'solid',
    //                     borderBottomColor: '#000',

    //                     borderLeftWidth: 1,
    //                     borderLeftStyle: 'solid',
    //                     borderLeftColor: '#000',

    //                     borderRightWidth: 1,
    //                     borderRightStyle: 'solid',
    //                     borderRightColor: '#000',

    //                     marginBottom: 5

    //                 }}
    //             >
    //                 <Text
    //                     // style={innerStyles.documentName}
    //                     style={{
    //                         textAlign: 'center',
    //                         fontSize: 30
    //                     }}
    //                 >
    //                     {/* {documentName.toUpperCase()} */}
    //                     {branchCodeDisplay}
    //                 </Text>
    //             </View>
    //             {/* <Text
    //                 style={innerStyles.documentName}
    //             >
    //                 {data?.location_name}
    //             </Text> */}
    //         </View>
    //     )
    // }

    const RenderSection3 = () => {

        // console.log('barCodeDatabarCodeDatabarCodeData', pageNumber, barCodeData[pageNumber - 1])

        return (
            <View
                style={{
                    height: 40,
                    width: "100%",

                    borderWidth: 1,
                    borderColor: '#000',
                    borderStyle: 'solid',
                    borderTopWidth: 0,
                    borderLeftWidth: 0,
                    borderRightWidth: 0,
                }}
            >
                <View
                    style={{
                        // backgroundColor: 'red',
                        // borderWidth: 1,
                        // borderColor: '#000',
                        // borderStyle: 'solid',
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',

                        paddingLeft: 5,
                    }}
                >
                    <Text style={[styles.boldTextFamilyCN, { marginTop: 5, fontSize: 17 }]}>{data?.marking}</Text>
                </View>
                <View
                    style={{
                        position: "absolute",
                        top: 0,
                        right: 0,
                        // backgroundColor: 'green',
                        width: 70,

                        // borderWidth: 1,
                        // borderColor: '#000',
                        // borderStyle: 'solid',
                    }}
                >
                    <Text style={[styles.normalTextFamilyCN, { textAlign: 'right', marginTop: 1, fontSize: 9, fontWeight: 800 }]}>顾客唛头</Text>
                    {/* <Image
                        src={barcodeDataUrl}
                        style={{
                            width: '80',
                            height: '40'
                        }}
                    /> */}
                </View>
            </View>
        )
    }

    return (
        <View style={{
            width: '100%',
            // marginBottom: 5,
            // backgroundColor: 'red'
        }}>
            <View
                style={{
                    // width: '50%',
                    // flexWrap: 'wrap'
                }}>
                <RenderSection1 />
            </View>
            <View
                style={{
                    // width: '50%',
                    // flexWrap: 'wrap'
                }}>
                <RenderSection3 />
            </View>
            {/* <View
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    // borderBottomColor: '#000',
                    // borderBottomStyle: 'solid',
                    // borderBottomWidth: 0.5,
                }}
            >
                <View
                    style={{
                        // width: '50%',
                        // flexWrap: 'wrap'
                    }}>
                    <RenderSection1 />
                </View>
            </View> */}
            {/* <View
                style={{
                    textAlign: 'right',
                    // display: 'flex',
                    // flexDirection: 'row',
                    // justifyContent: 'space-between',
                    // alignItems: 'center',
                }}
            >
                <Text style={styles.h10}>
                    {pageNumber} / {totalPages} ({data?.uom_lbl})
                </Text>
            </View> */}
        </View>
    )
}